"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.determineSupportedVideoCodecs = void 0;
const get_ios_version_1 = require("./get_ios_version");
const api_1 = require("@streem/api");
// ------------------------------------------------------------------------------- //
// Code below from Twilio Video: https://www.twilio.com/docs/video/managing-codecs //
// ------------------------------------------------------------------------------- //
/**
 * Test support for H264 codec.
 * @returns {Promise<boolean>} true if supported, false if not
 */
const PeerConnection = typeof RTCPeerConnection !== 'undefined'
    ? RTCPeerConnection
    : // @ts-ignore Removed from DOM-lib spec in Typescript 4.4 but Twilio hasn't revised their docs so leaving alone for now. https://github.com/microsoft/TypeScript-DOM-lib-generator/issues/1029
        typeof webkitRTCPeerConnection !== 'undefined'
            ? // @ts-ignore Removed from DOM-lib spec in Typescript 4.4 but Twilio hasn't revised their docs so leaving alone for now. https://github.com/microsoft/TypeScript-DOM-lib-generator/issues/1029
                webkitRTCPeerConnection
            : typeof mozRTCPeerConnection !== 'undefined'
                ? mozRTCPeerConnection
                : null;
function testH264Support() {
    return __awaiter(this, void 0, void 0, function* () {
        let isH264Supported;
        if (typeof isH264Supported === 'boolean') {
            return Promise.resolve(isH264Supported);
        }
        if (!PeerConnection) {
            isH264Supported = false;
            return Promise.resolve(isH264Supported);
        }
        const offerOptions = {};
        const pc = new PeerConnection();
        try {
            pc.addTransceiver('video');
        }
        catch (e) {
            offerOptions.offerToReceiveVideo = true;
        }
        return pc.createOffer(offerOptions).then((offer) => {
            isH264Supported = /^a=rtpmap:.+ H264/m.test(offer.sdp);
            return isH264Supported;
        });
    });
}
const isWebRTCSupported = !!PeerConnection;
function determineSupportedVideoCodecs(userAgent, browser) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!browser || browser.type != 'browser') {
            return []; // undetectable
        }
        const browserVersion = parseFloat(browser.version);
        const iOSplatformVersion = browser.os === 'iOS'
            ? parseFloat(`${(0, get_ios_version_1.getIosVersion)(userAgent).major}.${(0, get_ios_version_1.getIosVersion)(userAgent).minor}`)
            : 0;
        // For Safari/IOS, use the version numberss
        // @see https://www.twilio.com/docs/video/managing-codecs
        if (browser.name == 'safari' || browser.name == 'ios') {
            // Safari did not support WebRTC before version 11
            if (browserVersion < 11) {
                return [];
            }
            // Safari before 12.1 only supported H.264
            if (browserVersion < 12.1) {
                return [api_1.StreemApiDeviceSupportedVideoCodecs.H264];
            }
            // Safari == 15.1 + twilio-video crashes using H.264
            if (browserVersion == 15.1) {
                return [api_1.StreemApiDeviceSupportedVideoCodecs.VP8];
            }
            if (browserVersion >= 17) {
                return [
                    api_1.StreemApiDeviceSupportedVideoCodecs.H264,
                    api_1.StreemApiDeviceSupportedVideoCodecs.VP8,
                    api_1.StreemApiDeviceSupportedVideoCodecs.VP9,
                ];
            }
            return [api_1.StreemApiDeviceSupportedVideoCodecs.H264, api_1.StreemApiDeviceSupportedVideoCodecs.VP8];
        }
        // For other browsers, use feature detection and some browser checks
        let supportsVP8 = isWebRTCSupported;
        let supportsVP9 = false;
        let supportsH264 = yield testH264Support();
        // Bug: H.264 does not currently work with 'twilio-video' and iOS 15.1
        // https://github.com/twilio/twilio-video.js/issues/1611
        if (iOSplatformVersion == 15.1) {
            supportsH264 = false;
        }
        // Disable VP8 for Pixel 3 and Pixel 4 devices because of an issue with hardware encoding
        // https://bugs.chromium.org/p/chromium/issues/detail?id=1084702
        // https://streempro.atlassian.net/browse/STREEM-9903
        // https://streempro.atlassian.net/browse/STREEM-12269
        if (/Pixel [34]/.test(userAgent)) {
            supportsVP8 = false;
        }
        if (browser.name == 'chrome' || browser.name == 'crios') {
            supportsVP9 = browserVersion >= 48; // https://developers.google.com/web/updates/2016/01/vp9-webrtc
        }
        if (browser.name == 'firefox') {
            supportsVP9 = browserVersion >= 55; // https://www.twilio.com/docs/video/managing-codecs
        }
        if (browser.name == 'samsung') {
            // Would need access to the device model and possibly chipset...
            // https://en.wikipedia.org/wiki/VP9
        }
        const codecs = [];
        if (supportsVP8) {
            codecs.push(api_1.StreemApiDeviceSupportedVideoCodecs.VP8);
        }
        if (supportsVP9) {
            codecs.push(api_1.StreemApiDeviceSupportedVideoCodecs.VP9);
        }
        if (supportsH264) {
            codecs.push(api_1.StreemApiDeviceSupportedVideoCodecs.H264);
        }
        return codecs;
    });
}
exports.determineSupportedVideoCodecs = determineSupportedVideoCodecs;
// @ts-ignore
window.determineSupportedVideoCodecs = determineSupportedVideoCodecs;
//# sourceMappingURL=determine_supported_video_codecs.js.map